import { render, staticRenderFns } from "./OtherAbsenceInput.vue?vue&type=template&id=730b9ded"
import script from "./OtherAbsenceInput.vue?vue&type=script&lang=js"
export * from "./OtherAbsenceInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports